export default function WPImageGetter(content, className) {
  if (!content) return null

  const imageNode = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes(className)
  )[0]

  if (!imageNode) return null

  if (imageNode.rawTagName.toLowerCase() !== "figure") return null

  return imageNode.innerHTML
}
